<template lang="html">
  <svg
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 32.061 31.998"
  ><defs></defs><g transform="translate(0 0)"><g transform="translate(-5 -5.021)"><path d="M35.631,17.8A1.067,1.067,0,0,0,34.724,19,13.865,13.865,0,1,1,26.8,8.411a5.333,5.333,0,0,0,0,4.042,1.067,1.067,0,0,0,1.973-.8,3.2,3.2,0,1,1,1.984,1.877,1.068,1.068,0,0,0-.64,2.037,5.2,5.2,0,0,0,1.6.245,5.333,5.333,0,1,0-3.722-9.14l-.139-.107A16,16,0,1,0,37,21a16.425,16.425,0,0,0-.16-2.282,1.067,1.067,0,0,0-1.205-.917Z"/><path d="M23.575,15.31,19,19.9v7.9a1.067,1.067,0,1,0,2.133,0V20.77l3.957-3.946a1.071,1.071,0,1,0-1.514-1.514Z" transform="translate(0.931 0.664)"/><circle cx="1.067" cy="1.067" r="1.067" transform="translate(19.931 9.265)"/><circle cx="1.067" cy="1.067" r="1.067" transform="translate(19.931 30.595)"/><circle cx="2.133" cy="2.133" r="2.133" transform="translate(8.2 18.863)"/><circle cx="2.133" cy="2.133" r="2.133" transform="translate(29.53 18.863)"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/SessionsIcon.vue